<template>
  <div class="coming-soon-wrapper">
    <v-card class="pa-12 text-center coming-soon-card">
      <h1 class="text-h4 font-weight-medium mb-3">
        {{ $t('comingSoon') }}
      </h1>
      <p class="text-body-1 text--secondary mb-0" v-html="description"></p>
    </v-card>
    <div v-if="chickenSrc" class="coming-soon-chicken-container">
      <img
        :src="chickenSrc"
        class="coming-soon-chicken"
        alt=""
      />
    </div>
  </div>
</template>

<script>
const chickenImages = {
  'AIAssistant.png': require('@/assets/images/chickens/AIAssistant.png'),
  'comingSoon.png': require('@/assets/images/chickens/comingSoon.png'),
  'fleet.png': require('@/assets/images/chickens/fleet.png'),
  'immigration.png': require('@/assets/images/chickens/immigration.png'),
  'resources.png': require('@/assets/images/chickens/resources.png'),
  'sale.png': require('@/assets/images/chickens/sale.png'),
  'whatsappIntegration.png': require('@/assets/images/chickens/whatsappIntegration.png'),
  'workingTimeRecords.png': require('@/assets/images/chickens/workingTimeRecords.png'),
}

export default {
  computed: {
    description() {
      const key = this.$route.meta.comingSoonKey
      if (key && this.$te(`comingSoonDescriptions.${key}`)) {
        return this.$t(`comingSoonDescriptions.${key}`)
      }
      return this.$t('comingSoonDefault')
    },
    chickenSrc() {
      const key = this.$route.meta.chickenImage
      return key ? chickenImages[key] : null
    },
  },
}
</script>

<style scoped>
.coming-soon-wrapper {
  display: flex;
  flex-direction: column;
  height: calc((var(--vh, 1vh) * 100) - 64px - 56px - 1.5rem);
  max-height: calc((var(--vh, 1vh) * 100) - 64px - 56px - 1.5rem);
  margin-bottom: -1.5rem;
  overflow: hidden;
}

.coming-soon-card {
  flex-shrink: 0;
}

.coming-soon-chicken-container {
  flex: 1 1 0;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  margin-top: 2rem;
  margin-right: -1.5rem;
  min-height: 0;
  overflow: hidden;
}

.coming-soon-chicken {
  max-height: 100%;
  max-width: min(60vw, 100%);
  width: auto;
  height: auto;
  opacity: 0.35;
  pointer-events: none;
  object-fit: contain;
  object-position: bottom right;
}
</style>
